import React, { forwardRef } from "react";
import { createPortal } from "react-dom";

const ApplicationOverlay = forwardRef(function ApplicationOverlay(
  { className = "", children, portal = true, component: Component = "div", ...props },
  ref
) {
  if (typeof document === "undefined") return null;

  const overlay = (
    <Component ref={ref} className={`application-overlay ${className}`.trim()} {...props}>
      {children}
    </Component>
  );

  return portal ? createPortal(overlay, document.body) : overlay;
});

export default ApplicationOverlay;
